import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { useStarterDashboardV2PageData } from 'src/app/pages/starterDashboardV2/pageContext';
import { useTriggerVanityLinkModalReskin as useTriggerVanityLinkModal } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { getShareUrl } from '../../utils';

import { useShortUrls } from './useShortUrls';

type UseShareUrlReturn = ModelHookResult<{ canEditUrl: boolean; shareUrl: string }, { onEditUrl: () => Promise<void> }>;

export function useShareUrl(): UseShareUrlReturn {
	const { resolveUrl } = useUtilityContext();
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	// gets displayed url
	const shortUrls = useShortUrls({ slug: petition.slug });
	// concatenate after resolving, since resolveUrl will encode the string if its unicode and we want to show the un-encoded string
	const vanityUrl = petition.starterVanityUrl ? `${resolveUrl('/')}${petition.starterVanityUrl}` : null;
	const shareUrl = getShareUrl(vanityUrl, shortUrls.copy);

	const triggerVanityLinkModal = useTriggerVanityLinkModal();

	return {
		data: { canEditUrl: shareUrl.type !== 'vanity', shareUrl: shareUrl.url },
		actions: { onEditUrl: triggerVanityLinkModal },
	};
}
